import { ErrorMessage } from '@common/components/ErrorMessage';

export function UnexpectedError() {
  return (
    <ErrorMessage
      errorMessage={
        'サーバー内部エラーが発生しています。しばらくたってから再度アクセスしてみてください。'
      }
    />
  );
}
